import { PackageSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import * as React from "react";
import { observer } from "mobx-react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import {
  UitkLayoutGridItem,
  UitkLayoutConditionalGridSpan,
  UitkLayoutGrid,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { StaySomewhereElse } from "./StaySomewhereElse";
import { locKeys } from "../l10n";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";

export const PackageOnewayFlight = observer((props: PackageSubLOBProps) => {
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 8 };
  const datesColSpanOneway: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const fssseColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const datesHotelColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 8 };
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 2, medium: 12 };

  const { isFlightHotelOneWayFormValid, updateInvalidFormsState } = props.packageWizardState;

  if (isFlightHotelOneWayFormValid) {
    updateInvalidFormsState();
  }

  return (
    <>
      <UitkLayoutGrid columns={mainGridColumns} space="three">
        <Location
          originField={true}
          destinationField={true}
          showSwapLocationsControl={true}
          lobState={props.packageWizardState}
          colSpan={locationColSpan}
          onewayFlight={true}
        />
        <Dates
          lobState={props.packageWizardState}
          colSpan={datesColSpanOneway}
          singleDate={true}
          setInputsRefs={props.setInputsRefs}
        />

        <UitkLayoutGridItem colSpan="all">
          <h2 className="uitk-type-heading-600">{props.l10n.formatText(locKeys.hotelSectionLabel)}</h2>
        </UitkLayoutGridItem>

        <StaySomewhereElse lobState={props.packageWizardState} colSpan={fssseColSpan} />

        <Viewport>
          <ViewSmall>
            <Dates
              lobState={props.packageWizardState}
              isPartialStay={true}
              colSpan={datesHotelColSpan}
              stackedDates={true}
              setInputsRefs={props.setInputsRefs}
            />
          </ViewSmall>
          <ViewMedium>
            <Dates
              lobState={props.packageWizardState}
              isPartialStay={true}
              colSpan={datesHotelColSpan}
              setInputsRefs={props.setInputsRefs}
            />
          </ViewMedium>
        </Viewport>
      </UitkLayoutGrid>
    </>
  );
});
